module.exports = __webpack_public_path__ + "static/theo-companies-mindshare@2x-f0afac9f27afa9fd868aaaa381265d65.png";